/*
  This is a lookup table for error messages as used in FormController
  with Formifier.
  To add new a custom error message, add a new line to the `errorMessages` object
  where the key is the **name of the form field input** and the value is an
  object literal where that object's key(s) correspond to form constraint
  validations and the value(s) are string custom message(s).

  See https://html.spec.whatwg.org/#the-constraint-validation-api for available
  constraint validations.

  See https://docs.ramseysolutions.net/standards/dev-standards/forms/validations/index.html
  for validation error messaging.

  See https://github.com/lampo/formifier/#usage for information about Formifier.
*/

export const errorMessages = {
  // Invoice Payment
  'check_payment[first_name]': {
    valueMissing: 'Please enter a first name.',
    tooLong: 'Please enter 40 characters or less for a first name.',
  },
  'check_payment[last_name]': {
    valueMissing: 'Please enter a last name.',
    tooLong: 'Please enter 80 characters or less for a last name.',
  },
  'check_payment[phone_number]': {
    valueMissing: 'Please enter a phone number.',
    tooLong: 'Please enter 14 characters or less for a phone number.',
    patternMismatch: 'Please enter a valid phone number.',
  },
  'check_payment[email]': {
    valueMissing: 'Please enter an email address.',
    tooLong: 'Please enter 80 characters or less for an email address.',
    patternMismatch: 'Please enter a valid email address.',
  },
  'check_payment[referral_fee]': {
    rangeUnderflow: 'Please enter the payment amount.',
    valueMissing: 'Please enter the payment amount.',
  },
  'bank_pay_form[referral_fee]': {
    rangeUnderflow: 'Please enter the payment amount.',
    valueMissing: 'Please enter the payment amount.',
  },
  'bank_pay_form[first_name]': {
    valueMissing: 'Please enter a first name.',
    tooLong: 'Please enter 40 characters or less for a first name.',
  },
  'bank_pay_form[last_name]': {
    valueMissing: 'Please enter a last name.',
    tooLong: 'Please enter 80 characters or less for a last name.',
  },
  'bank_pay_form[phone_number]': {
    valueMissing: 'Please enter a phone number.',
    tooLong: 'Please enter 14 characters or less for a phone number.',
    patternMismatch: 'Please enter a valid phone number.',
  },
  'bank_pay_form[email]': {
    valueMissing: 'Please enter an email address.',
    tooLong: 'Please enter 80 characters or less for an email address.',
    patternMismatch: 'Please enter a valid email address.',
  },
  'bank_pay_form[bank_name]': {
    valueMissing: 'Please enter the name of your bank.',
    tooLong: 'Please enter 100 characters or less for the name of your bank.',
  },
  'bank_pay_form[account_number]': {
    valueMissing: 'Please enter your bank account number.',
    patternMismatch: 'Please enter a valid bank account number.',
    tooLong: 'Please enter 17 digits or less for your bank account number.',
  },
  'bank_pay_form[routing_number]': {
    valueMissing: 'Please enter your bank routing number.',
    patternMismatch: 'Please enter a valid bank routing number.',
    tooLong: 'Please enter your 9-digit bank routing number.',
  },
  'forward_form[email_recipient]': {
    valueMissing: 'Please enter an email address.',
    tooLong: 'Please enter 80 characters or less for an email address.',
    patternMismatch: 'Please enter a valid email address.',
  },

  // Billing Information
  'existing_payment_method[select_draft_account]': {
    valueMissing: 'Please select a saved bank account.',
  },
  'create_payment_method[account_number]': {
    valueMissing: 'Please enter your bank account number.',
    patternMismatch: 'Please enter a valid bank account number.',
    tooLong: 'Please enter 17 digits or less for your bank account number.',
  },
  'create_payment_method[routing_number]': {
    valueMissing: 'Please enter your bank routing number.',
    patternMismatch: 'Please enter a valid bank routing number.',
    tooLong: 'Please enter your 9-digit bank routing number.',
  },
  'create_payment_method[account_nick_name]': {
    valueMissing: 'Please enter a nickname for this account.',
    tooLong: 'Please enter 50 characters or less for your account nickname.',
  },
  'create_payment_method[first_name]': {
    valueMissing: 'Please enter the account holder first name.',
    tooLong:
      'Please enter 40 characters or less for the account holder first name.',
  },
  'create_payment_method[last_name]': {
    valueMissing: 'Please enter the account holder last name.',
    tooLong:
      'Please enter 80 characters or less for the account holder last name.',
  },

  // Contact Support
  'contact_support[first_name]': {
    valueMissing: 'Please enter a first name.',
    tooLong: 'Please enter 40 characters or less for a first name.',
  },
  'contact_support[last_name]': {
    valueMissing: 'Please enter a last name.',
    tooLong: 'Please enter 80 characters or less for a last name.',
  },
  'contact_support[phone_number]': {
    valueMissing: 'Please enter a phone number.',
    tooLong: 'Please enter 14 characters or less for a phone number.',
    patternMismatch: 'Please enter a valid phone number.',
  },
  'contact_support[email]': {
    valueMissing: 'Please enter an email address.',
    tooLong: 'Please enter 80 characters or less for an email address.',
    patternMismatch: 'Please enter a valid email address.',
  },
  'contact_support[program]': {
    valueMissing: 'Please select a program.',
  },
};
